import { Send, MessageCircle } from "lucide-react";

export default function Footer() {
  const shareUrl = typeof window !== "undefined" ? window.location.origin : "";
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 px-6 py-20 md:px-16 lg:px-24">
      <div className="mx-auto grid max-w-[1600px] grid-cols-1 gap-14 md:grid-cols-12">
        <div className="md:col-span-6">
          <p className="mb-6 font-heading text-3xl font-black uppercase tracking-tighter md:text-5xl">
            Rocky <span className="text-[#FFD700]">Agency</span>
          </p>
          <p className="max-w-md text-sm leading-relaxed text-[#A1A1A6]">
            Daily Dear, KL & Golden Raja charts — organised, downloadable and shareable in one tap.
            உங்க சார்ட்கள், ஒரே இடத்தில்.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="mb-6 font-mono text-[10px] uppercase tracking-[0.25em] text-[#666666]">Variants</p>
          <ul className="space-y-3 text-sm text-[#A1A1A6]">
            <li>Dear — 1PM · 6PM · 8PM</li>
            <li>KL — 3PM</li>
            <li>Golden Raja — 5D · 4D · 3D</li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="mb-6 font-mono text-[10px] uppercase tracking-[0.25em] text-[#666666]">Share</p>
          <div className="flex gap-3">
            <a
              data-testid="footer-whatsapp-share"
              href={`https://wa.me/?text=${encodeURIComponent(`Daily charts on Rocky Agency\n${shareUrl}`)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex h-11 w-11 items-center justify-center rounded-full border border-white/10 text-[#A1A1A6] transition-colors duration-300 hover:bg-[#25D366] hover:text-black"
            >
              <MessageCircle className="h-4 w-4" />
            </a>
            <a
              data-testid="footer-telegram-share"
              href={`https://t.me/share/url?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent("Daily charts on Rocky Agency")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex h-11 w-11 items-center justify-center rounded-full border border-white/10 text-[#A1A1A6] transition-colors duration-300 hover:bg-[#229ED9] hover:text-white"
            >
              <Send className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>
      <div className="mx-auto mt-16 flex max-w-[1600px] items-center justify-between border-t border-white/5 pt-8">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#666666]">
          © {new Date().getFullYear()} Rocky Agency
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#666666]">Made to be forwarded</p>
      </div>
    </footer>
  );
}
